import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistCombineReducers } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./authSlice";
import postsReducer from "./postsSlice";

// Persist Configuration (Combining reducers)
// Only persist auth, NOT posts (posts should always be fetched fresh)
const persistConfig = {
    key: "root",
    storage,
    blacklist: ['posts'], // Don't persist posts - always fetch fresh from API
};

// Combine persisted reducers
const rootReducer = persistCombineReducers(persistConfig, {
    auth: authReducer,
    posts: postsReducer,
});

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    'persist/PERSIST',
                    'persist/REHYDRATE',
                    'persist/REGISTER',
                    'persist/PAUSE',
                    'persist/PURGE',
                    'persist/FLUSH'
                ],
                ignoredPaths: ['register', 'rehydrate']
            },
        }),
});

const persistor = persistStore(store);

// Clean up stale key from old double-persistence setup
if (typeof window !== 'undefined') {
    localStorage.removeItem('persist:auth');
}

export { store, persistor };
